import React from "react";

const LoggingIn = () => {
    return (
        <div className="d-flex justify-content-center loggingIn-spinner flex-column">
            <div className="spinner-border" role="status" style={{width: "3rem", height: "3rem"}}>
                <span className="visually-hidden">Loading...</span>
            </div>
            <div className="login-sub pt-2 fw-bold">Creating your Partner account</div>
        </div>
    )
}

export default LoggingIn;